/* Ziggy Cuts — product-form.js
   Variant selection via option pills. Updates price, hidden
   variant id, and buy-button state. No dependencies. */

(function () {
  'use strict';

  var root = document.querySelector('[data-product-form]');
  if (!root) return;

  var variants = JSON.parse(root.querySelector('[data-variants-json]').textContent);
  var idInput = root.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-product-price]');
  var buyBtn = root.querySelector('[type="submit"]');
  var buyLabel = buyBtn.dataset.label;
  var soldOutLabel = buyBtn.dataset.soldOutLabel;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function selectedOptions() {
    return [...root.querySelectorAll('[data-option-index]')].map(function (group) {
      var active = group.querySelector('[aria-pressed="true"]');
      return active ? active.dataset.value : null;
    });
  }

  function findVariant(opts) {
    return variants.find(function (v) {
      return opts.every(function (val, i) {
        return val === null || v.options[i] === val;
      });
    });
  }

  function update() {
    var opts = selectedOptions();
    var variant = findVariant(opts);
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    var ok = variant.available;
    buyBtn.disabled = !ok;
    buyBtn.textContent = ok ? buyLabel : soldOutLabel;
    /* Broadcast the selected scent (option1) so recommendations can react */
    document.dispatchEvent(new CustomEvent('ziggy:variant', { detail: { scent: opts[0] } }));
  }

  root.querySelectorAll('[data-option-index]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-value]');
      if (!btn) return;
      group.querySelectorAll('[data-value]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      update();
    });
  });

  update();
})();
